import { Context } from "types";

export const getTimezones =
  ({ apiClient }: Context) =>
  () =>
    apiClient<App.Domain.API.Timezones.Resources.TimezonesResource>({
      url: "/timezones",
      method: "GET",
    });
